<template>
  <div class="customer-detail-header c:row-center">
    <div class="customer-detail-kv">
      <img :src="data.customerAvatar" alt="" />
    </div>
    <div class="customer-detail-desc c:col-center-start">
      <p class="customer-name">
        {{ data.customerNickname }}
        <img
          v-if="data.customerGender === 2"
          src="@/assets/icons/female.svg"
          class="gender-icon"
          alt=""
        />
        <img
          v-if="data.customerGender === 1"
          src="@/assets/icons/male.svg"
          class="gender-icon"
          alt=""
        />
      </p>
      <p class="customer-phone"></p>
      <p class="customer-amount">总消费金额：￥ {{ formattedPrice }}</p>
    </div>
  </div>
</template>

<script>
import { outputmoney } from "@/utils";

export default {
  props: { data: Object },
  computed: {
    formattedPrice() {
      return outputmoney(this.data?.totalPrice || 0);
    },
    formattedTime() {
      return this.$moment(this.data?.lastOrderTime || 0).format(
        "YYYY-MM-DD HH:mm:ss"
      );
    },
  },
};
</script>

<style lang="less" scoped>
.customer-detail-header {
  gap: 14/20rem;

  width: 100%;
  height: 82/20rem;
  padding: 10/20rem 20/20rem;
  background-color: #fff;
  border-bottom: solid 1px #e8e8e8;

  .customer-detail-kv {
    width: 46/20rem;
    height: 46/20rem;
    border-radius: 50%;
    overflow: hidden;

    img {
      width: 46/20rem;
      height: 46/20rem;
    }
  }

  .customer-detail-desc {
    gap: 4/20rem;

    flex: 1;
    width: 0;

    .customer-name {
      height: 20/20rem;
      line-height: 20/20rem;
      font-size: 14/20rem;
      font-weight: 500;
      color: #000;

      .gender-icon {
        width: 8/20rem;
        height: 8/20rem;
        margin-left: 6/20rem;
      }
    }

    .customer-phone,
    .customer-amount {
      height: 17/20rem;
      line-height: 17/20rem;
      font-weight: 400;
      font-size: 12/20rem;
      letter-spacing: 0;
      color: #b3b3b3;
    }
  }
}
</style>
